import { Rating } from '@avanta/shared/components/Rating';
import { LOCIZE_NS, type Languages } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { useUserStore } from 'stores/user';
import type { Appointment } from 'types/appointments';

interface PsychologistInfoProps {
  appointment: Appointment;
}

export const PsychologistInfo = ({ appointment }: PsychologistInfoProps): React.ReactElement => {
  const language = useUserStore(state => state.user?.appLanguage);
  const psychologist = appointment.psychologist?.psychologist;
  const averageRate = psychologist?.averageRate;
  const presentation = psychologist?.presentations?.[language as Languages];
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-md font-medium text-denim-600">
        {t('AppointmentCard.psychologist.label')}
      </p>
      <div className="flex gap-2">
        <img
          className="w-14 h-14 rounded-2xl"
          src={psychologist?.imageSquare}
          alt={psychologist?.name}
        />
        <div className="flex flex-col gap-1 w-full">
          <h3 className="font-semibold text-denim-600 flex flex-col items-start">
            <span>{psychologist?.name}</span>
            <span>{psychologist?.surname}</span>
          </h3>
          <Rating rating={averageRate} numberOfRatings={psychologist?.numberOfRatings} />
          {presentation && <p className="text-sm text-gray-600 line-clamp-4">{presentation}</p>}
        </div>
      </div>
    </div>
  );
};
